import { SizeImage } from './image'

export interface MediaLibraryItem {
  id: number
  image_id: number
  image: SizeImage | null
  preview: string
  image_type?: string
}

export interface MediaLibraryImageItem extends MediaLibraryItem {
  image_id: number
  id: number
}

export enum MediaLibraryEssence {
  ARTICLE = 'article',
  ISSUE = 'issue',
  EXPERT = 'expert',
  PODCAST_EPISODE = 'podcast_episode',
  PODCAST = 'podcast',
  RECIPE = 'recipe',
  CONTEST = 'contest',
  FEATURE_ARTICLE = 'feature_article',
  TECHNICAL = 'technical',
  TEST = 'test',
  TEASER = 'teaser',
}

export interface MediaLibrary {
  essence: MediaLibraryEssence
  essenceId: number
}

export interface MediaLibraryImage extends MediaLibrary {
  image_id: number
  image_file?: File
  image_type?: string
}

export interface MediaLibraryParams extends MediaLibrary {
  count: number
  page: number
}
